<template>
    <div :class="$style.end">
        <Button
            interfaceTarget="random-game"
            size="l"
            :target="props.targetUrl"
            :to="{ name: ROUTE_NAMES.RANDOM_GAME }"
            :class="$style.button_override"
            :label="$tr('theEnd.random_game')"
        />
        <Button
            interfaceTarget="scroll-to-top"
            size="l"
            color="purple-graphite"
            leftIcon="scroll-to-top"
            :class="$style.button_override"
            :label="$tr('theEnd.back_to_top')"
            @click="scrollToTop"
        />
    </div>
</template>

<script setup lang="ts">
import Button from '@/components/Buttons/Button.vue'
import { ROUTE_NAMES } from '@/router/constants'

const props = defineProps<{
    targetUrl?: '_blank'
}>()

function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
}
</script>

<style module>
.end {
    padding: 20px 0;
    display: flex;
    justify-content: center;
    gap: 10px;
}

.button_override {
    flex: 1 1 auto;
    height: 56px;
}

@media (--desktop-small-plus) {
    .button_override {
        flex: 0 0 auto;
        padding: 0 48px;
    }
}
</style>
